<div class="gif" *ngIf="type == 'gif'" (click)="launchGame()">
    <img [src]="imageThumbnailSrc" [lazyLoad]="url" />
</div>
<div class="svg" *ngIf="type == 'svg'" (click)="launchUrl ? launchGame() : false">
    <img [src]="imageThumbnailSrc" [lazyLoad]="url" />
</div>
